<template>
    <v-layout v-if="payment_status" column align-center justify-center align-content-center>
        <v-spacer class="my-4"></v-spacer>
        <v-icon v-if="payment_status === '1'" color="green" style="font-size: 150px">fal fa-check-circle</v-icon>
        <v-icon v-else-if="payment_status === '0'" color="yellow" style="font-size: 150px">fal fa-check-circle</v-icon>
        <v-icon v-else-if="payment_status === '-1'" color="red" style="font-size: 150px">fal fa-ban</v-icon>
        <v-spacer class="my-4"></v-spacer>
        <h1>{{ $vuetify.t('$vuetify.thank_you') }}</h1>
        <h2>{{ $vuetify.t('$vuetify.shop.order_complete') }}</h2>

        <div v-if="payment_entity && payment_reference && payment_value">
            <v-spacer class="my-4"></v-spacer>
            <h3 style="text-align: left;">{{ $vuetify.t('$vuetify.shop.order_payment_entity') }}</h3><span>{{payment_entity}}</span>
            <h3 style="text-align: left;">{{ $vuetify.t('$vuetify.shop.order_payment_reference') }}</h3><span>{{payment_reference}}</span>
            <h3 style="text-align: left;">{{ $vuetify.t('$vuetify.shop.order_payment_value') }}</h3><span>{{payment_value}}</span>
        </div>
        <div v-else>
            <v-spacer class="my-4"></v-spacer>
            <h2 v-if="payment_status === '1'">{{ $vuetify.t('$vuetify.shop.order_payment_success') }}</h2>
            <h2 v-else-if="payment_status === '0'">{{ $vuetify.t('$vuetify.shop.order_payment_pending') }}</h2>
            <h2 v-else>{{ $vuetify.t('$vuetify.shop.order_payment_error') }}</h2>
        </div>

        <v-spacer class="my-4"></v-spacer>
                <div class="text-xs-center">
                    <v-btn
                            @click="goTo"
                            class="primary"
                            large
                    >
                        <!-- The button can go to the Catalog or to the My Orders list-->
                        <!-- {{ $vuetify.t('$vuetify.shop.buy') }}-->
                        {{  $vuetify.t('$vuetify.shop.my_orders') }}
                        <v-icon right small>fal fa-angle-double-right</v-icon>
                    </v-btn>
                </div>

    </v-layout>
</template>

<script>
    import {ordersService} from '@/_services';
    import {getErrorMessage} from '@/_helpers';


    export default {
        name: "OrderCompleted",
        data: () => ({
            payment_entity: null,
            payment_reference: null,
            payment_value: null,
            customer_purchase: null,
            payment_status: null
        }),
        methods: {
            /**
             * The method assigned to the button which is displayed at the End of the Purchase. This button
             * redirects the user to the Catalog or to the My Orders List
             **/
            goTo() {
                // The button can go to the Catalog or to the My Orders List
                // this.$router.push({name: "catalog"});
                this.$router.push({name: "orders"});
            },
        },
        mounted() {
            //It is necessary to know the Customer's Purchase identifier,
            //  since its Payment Status/Information will be checked
            //If the User arrives to this interface after using the Credit Card to pay the Order,
            // the Customer's Purchase identifier is given by the notification URL provided by the Payment Gateway Provider: query['t_key']
            //Otherwise, the Customer's Purchase identifier was concatenated to the URL
            if (this.$route.params.order) {
                this.customer_purchase = this.$route.params.order;
            } else {
                this.customer_purchase = this.$route.query['t_key']
            }

            //Checking the Customer's Purchase Payment Status/Information
            if (this.customer_purchase) {
                ordersService.getOrderPaymentStatus(this.customer_purchase).then(result => {
                        this.payment_status = result['payment']['status'];
                        if (result['payment']['entity']) {
                            this.payment_entity = result['payment']['entity'];
                        }
                        if (result['payment']['reference']) {
                            this.payment_reference = result['payment']['reference']
                        }
                        if (result['payment']['value']) {
                            this.payment_value = result['payment']['value']
                        }
                    },
                    error => {
                        getErrorMessage(error, 'Getting the Order Payment Status', this);
                    }
                );
            }

        },
    }
</script>

<style scoped>

</style>